import RecepcionService from "@/services/wms/RecepcionService";
import ContenedorService from "@/services/wms/ContenedorService";
import RutaService from "@/services/wms/RutaService";

const fetch = (context, params) => {
  return RecepcionService.fetch(params)
    .then(res => {
      context.commit('RECEPCIONES', res.data);
    });
};

const contenedores = (context, params) => {
  return ContenedorService.fetch(params)
    .then(res => {
      context.commit('CONTENEDORES', res.data);
    });
};

const rutas = (context, params) => {
  return RutaService.fetch(params)
    .then(res => {
      context.commit('RUTAS', res.data);
    });
};

// New actions for invoice persistence
const selectInvoice = (context, invoice) => {
  context.commit('SET_SELECTED_INVOICE', invoice);
};

const setReceiptType = (context, type) => {
  context.commit('SET_RECEIPT_TYPE', type);
};

const clearInvoiceState = (context) => {
  context.commit('CLEAR_INVOICE_STATE');
};

export default {
  fetch,
  contenedores,
  rutas,
  selectInvoice,
  setReceiptType,
  clearInvoiceState
};